var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfilePlaceholder = function SvgProfilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 11.625,
    fill: "#D1D6DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-3.743 6.75c-.83 0-1.507.665-1.507 1.5 0 1.268.625 2.225 1.601 2.847C9.313 17.71 10.61 18 12 18s2.687-.29 3.649-.903c.976-.622 1.601-1.579 1.601-2.847a1.5 1.5 0 0 0-1.5-1.5H8.257Z",
    fill: "#323A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 11.625,
    stroke: "#A3ACB5",
    strokeWidth: 0.75
  })));
};

export { SvgProfilePlaceholder as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeD0iMC4zNzUiIHk9IjAuMzc1IiB3aWR0aD0iMjMuMjUiIGhlaWdodD0iMjMuMjUiIHJ4PSIxMS42MjUiIGZpbGw9IiNEMUQ2REUiIC8+CiAgPHBhdGggZD0iTTEyIDZDMTAuMzQzMSA2IDkgNy4zNDMxNSA5IDlDOSAxMC42NTY5IDEwLjM0MzEgMTIgMTIgMTJDMTMuNjU2OSAxMiAxNSAxMC42NTY5IDE1IDlDMTUgNy4zNDMxNSAxMy42NTY5IDYgMTIgNlpNOC4yNTY1NCAxMi43NUM3LjQyNzM2IDEyLjc1IDYuNzUgMTMuNDE1MiA2Ljc1IDE0LjI1QzYuNzUgMTUuNTE4NCA3LjM3NDYxIDE2LjQ3NDcgOC4zNTEyNSAxNy4wOTc0QzkuMzEyNzMgMTcuNzEwNSAxMC42MDg5IDE4IDEyIDE4QzEzLjM5MTEgMTggMTQuNjg3MyAxNy43MTA1IDE1LjY0ODggMTcuMDk3NEMxNi42MjU0IDE2LjQ3NDcgMTcuMjUgMTUuNTE4NCAxNy4yNSAxNC4yNUMxNy4yNSAxMy40MjE3IDE2LjU3ODQgMTIuNzUgMTUuNzUgMTIuNzVMOC4yNTY1NCAxMi43NVoiIGZpbGw9IiMzMjNBNDYiIC8+CiAgPHJlY3QgeD0iMC4zNzUiIHk9IjAuMzc1IiB3aWR0aD0iMjMuMjUiIGhlaWdodD0iMjMuMjUiIHJ4PSIxMS42MjUiIHN0cm9rZT0iI0EzQUNCNSIgc3Ryb2tlLXdpZHRoPSIwLjc1IiAvPgo8L3N2Zz4KICA=";